var map = {
	"./bank-transfer.svg": 950,
	"./betnearn-ico.svg": 951,
	"./birthday-bonus-ico.svg": 952,
	"./birthday.svg": 953,
	"./bonus-code-ico.svg": 954,
	"./bonus-ico.svg": 955,
	"./bonus-received-ico.svg": 956,
	"./bonus.svg": 957,
	"./business-account-upgrade-ico.svg": 958,
	"./check-in-daily-ico.svg": 959,
	"./checked.svg": 960,
	"./cloud-pointer.svg": 961,
	"./crypto.svg": 962,
	"./daily-bonus-ico.svg": 963,
	"./daily-limit.svg": 964,
	"./deposit-delay-bonus-ico.svg": 965,
	"./e-wallet.svg": 966,
	"./earn-x33-coin-ico.svg": 967,
	"./email.svg": 968,
	"./facebook.svg": 969,
	"./feedback.svg": 970,
	"./first-bet-ico.svg": 971,
	"./games-rebate-ico.svg": 972,
	"./info.svg": 973,
	"./instagram.svg": 974,
	"./live-casino-rebate-ico.svg": 975,
	"./lucky-spin-ico.svg": 976,
	"./messenger.svg": 977,
	"./mobile-app-deposit-ico.svg": 978,
	"./monthly-cash.svg": 979,
	"./msg-activity.svg": 980,
	"./msg-ann.svg": 981,
	"./msg-notice.svg": 982,
	"./new-icon.svg": 983,
	"./people-ico.svg": 984,
	"./quick-pay.svg": 985,
	"./rescue-bonus-ico.svg": 986,
	"./rescue-lc-ico.svg": 987,
	"./rescue-slots-ico.svg": 988,
	"./return.svg": 989,
	"./sc-bc-active-ico.svg": 990,
	"./sc-bc-ico.svg": 991,
	"./sc-bi-active-ico.svg": 992,
	"./sc-bi-ico.svg": 993,
	"./sc-mail-active-ico.svg": 994,
	"./sc-mail-ico.svg": 995,
	"./sc-mp-active-ico.svg": 996,
	"./sc-mp-ico.svg": 997,
	"./sc-pin-active-ico.svg": 998,
	"./sc-pin-ico.svg": 999,
	"./slots-rebate-ico.svg": 1000,
	"./sports-rebate-ico.svg": 1001,
	"./telegram.svg": 1002,
	"./twitter.svg": 1003,
	"./vip-up-level-ico.svg": 1004,
	"./vip-weekly-bonus.svg": 1005,
	"./wallet-balance-interest-ico.svg": 1006,
	"./wallet-ico.svg": 1007,
	"./weekly-tournament-ico.svg": 1008,
	"./welcome-bonus-ico.svg": 1009,
	"./whatsapp.svg": 1010,
	"./withdrawal-delay-bonus-ico.svg": 1011,
	"./withdrawal.svg": 1012,
	"./x33-coin.svg": 1013
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60;